export enum CollateralMappingType {
    auto = 'AUTO',
    manual = 'MANUAL',
}
